import React, { useEffect, useState } from "react";
import axiosInstance from "../api/axiosInstance";
import { useNavigate } from "react-router-dom";
import LoadingAnimation from "../components/LoadingAnimation";
export default function CartPage() {

  const [items, setItems] = useState([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(true);

  const navigate = useNavigate();

useEffect(() => {
  fetchCart();
}, []);

  /* ---------------- FETCH CART ---------------- */

  async function fetchCart() {
    setLoading(true);

    try {

      const res = await axiosInstance.get("/cart/");
      const data = res.data;

      let resolvedItems = [];
      let resolvedTotal = 0;

      if (Array.isArray(data)) {

        resolvedItems = data;

        resolvedTotal = resolvedItems.reduce(
          (acc, it) =>
            acc +
            (Number(it.total_price ?? 0) * Number(it.quantity ?? 1)),
          0
        );

      } else {

        resolvedItems = Array.isArray(data.items) ? data.items : [];
        resolvedTotal = Number(data.total_amount ?? 0);

      }

      setItems(resolvedItems);
      setTotal(resolvedTotal);

    } catch (err) {

      console.error("Cart fetch error:", err);

      if (err.response?.status === 401) {
        alert("Please login");
        navigate("/login");
      } else {
        alert("Failed to load cart");
      }

      setItems([]);
      setTotal(0);

    } finally {
      setLoading(false);
    }
  }

  /* ---------------- UPDATE QTY ---------------- */

const updateQuantity = async (itemId, cartType, actionType) => {

  // UI instantly update
  setItems(prev =>
    prev.map(item => {
      if (item.id === itemId) {
        let newQty = item.quantity;

        if (actionType === "plus") newQty += 1;
        if (actionType === "minus") newQty = Math.max(1, newQty - 1);

        return {
          ...item,
          quantity: newQty,
          total_price: newQty * item.price
        };
      }
      return item;
    })
  );

  try {

    const action = actionType === "plus" ? "increase" : "decrease";

    await axiosInstance.post("/cart/update/", {
      item_id: itemId,
      cart_type: cartType,
      action: action
    });

  } catch (err) {

    console.error("Update error:", err);

    // agar error aaye to cart reload
    fetchCart();

  }
};

  /* ---------------- REMOVE ITEM ---------------- */

async function removeItem(itemId, cartType) {

  if (!window.confirm("Remove this item?")) return;

  // UI se instantly remove
  setItems(prev => prev.filter(item => item.id !== itemId));

  try {

    await axiosInstance.post("/cart/remove/", {
      item_id: itemId,
      cart_type: cartType
    });

  } catch (err) {

    console.error("Remove error:", err);

    // error ho to reload
    fetchCart();

  }
}
useEffect(() => {

  const newTotal = items.reduce(
    (acc, it) => acc + (it.price * it.quantity),
    0
  );

  setTotal(newTotal);

}, [items]);

  /* ---------------- RENDER ITEM ---------------- */

function renderItemRow(item) {

  const name = item.name ?? item.product_name ?? "(No name)";
  const price = Number(item.price ?? 0);
  const qty = Number(item.quantity ?? 1);
  const img = item.image ?? null;
  const lineTotal = Number(item.total_price ?? 0);

  return (
    <div
      key={item.id}
      style={{
        display: "flex",
        gap: 10,
        padding: "12px",
        borderBottom: "1px solid #eee",
        alignItems: "center",
        background: "#fff",
        borderRadius: 10,
        marginBottom: 10
      }}
    >

      {/* IMAGE */}
      <div
        style={{
          width: 60,
          height: 60,
          borderRadius: 8,
          background: "#f6f6f6",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          overflow: "hidden"
        }}
      >
        {img ? (
          <img
            src={img.startsWith("http") ? img : `https://medical-backend-cgj8.onrender.com${img}`}
            alt={name}
            style={{ width: "100%", height: "100%", objectFit: "contain" }}
          />
        ) : (
          <span style={{ fontSize: 12 }}>No Image</span>
        )}
      </div>

      {/* INFO */}
      <div style={{ flex: 1, minWidth: 0 }}>

        <div style={{ fontWeight: 600, fontSize: 14 }}>
          {name}
        </div>

        <div style={{ color: "#666", fontSize: 13 }}>
          ₹{price.toFixed(2)}
        </div>

        {/* QTY CONTROLS */}
        <div
          style={{
            marginTop: 6,
            display: "flex",
            alignItems: "center",
            gap: 10
          }}
        >

          <button
  onClick={() => updateQuantity(item.id, item.cart_type, "minus")}
  style={qtyBtn}
>
  -
</button>

          <div style={{ fontWeight: 600 }}>
            {qty}
          </div>

          <button
            onClick={() => updateQuantity(item.id, item.cart_type, "plus")}
            style={qtyBtn}
          >
            +
          </button>

        </div>

      </div>

      {/* TOTAL */}
      <div style={{ textAlign: "right" }}>
        <div style={{ fontWeight: 700 }}>
          ₹{lineTotal.toFixed(2)}
        </div>

        <button
          onClick={() => removeItem(item.id, item.cart_type)}
          style={removeBtn}
        >
          Remove
        </button>

      </div>

    </div>
  );
}

  /* ---------------- LOADING ---------------- */

  if (loading) {
  return <LoadingAnimation />;
}

  /* ---------------- UI ---------------- */

  return (
    <div
  style={{
    padding: "20px 14px",
    paddingTop: "max(20px, env(safe-area-inset-top))",
    paddingBottom: "max(80px, env(safe-area-inset-bottom))",
    maxWidth: 600,
    margin: "0 auto"
  }}
>

      <h1>Your Cart</h1>

      {items.length === 0 ? (

        <div style={{ marginTop: 12 }}>
          <strong>No items in cart</strong>

          <div style={{ marginTop: 14 }}>
            <button
              onClick={() => navigate("/customer-dashboard")}
              style={primaryBtnStyle}
            >
              Continue Shopping
            </button>
          </div>
        </div>

      ) : (

        <>
          <div style={{ marginTop: 12 }}>
            {items.map((it) => renderItemRow(it))}
          </div>

          <div
            style={{
              marginTop: 20,
              borderTop: "1px solid #ddd",
              paddingTop: 12,
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <div style={{ fontSize: 18, fontWeight: 700 }}>
              Grand Total: ₹{Number(total).toFixed(2)}
            </div>

            <button
              onClick={() => navigate("/checkout")}
              style={primaryBtnStyle}
            >
              Checkout
            </button>

          </div>
        </>

      )}

    </div>
  );
}

/* ---------------- STYLES ---------------- */

const smallBtnStyle = {
  padding: "6px 10px",
  borderRadius: 6,
  border: "1px solid #ccc",
  background: "#fff",
  cursor: "pointer",
};


const linkBtnStyle = {
  padding: "6px 10px",
  borderRadius: 6,
  border: "none",
  background: "transparent",
  color: "#d32f2f",
  cursor: "pointer",
};
const qtyBtn = {
  width: 36,
  height: 36,
  minWidth: 36,
  minHeight: 36,
  borderRadius: 8,
  border: "1px solid #ccc",
  background: "green",
  fontSize: 20,
  fontWeight: "bold",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  cursor: "pointer",
  flexShrink: 0
};
const removeBtn = {
  marginTop: 4,
  fontSize: 12,
  background: "transparent",
  border: "none",
  color: "#d32f2f",
  cursor: "pointer"
};

const primaryBtnStyle = {
  padding: "12px 18px",
  borderRadius: 8,
  border: "none",
  background: "#0b79f7",
  color: "#fff",
  cursor: "pointer",
  fontWeight: 600
};